import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import {getStates} from "utils/i18n";

/**
 * A wrapper for a ReactSelect component that picks states.  Takes all the normal ReactSelect params plus some specific ones.
 */
export default class StateSelect extends React.Component {
  constructor() {
    super();
  }

  static propTypes = {
    clearable: PropTypes.bool,
    filter: PropTypes.func, // Function to tell whether to include a state
    matchPos: PropTypes.string, // Match only by leading letters, not anywhere in the string
    getOptionLabel: PropTypes.func, // ReactSelect prop to get the display label for a state.  Default (c)=>c.label
    getOptionValue: PropTypes.func, // Use if you need a different format than the value.  Default (c)=>c.value
    country: PropTypes.string // 2-letter code for country to get states for. Default "US",
  };

  static defaultProps ={
    clearable: true,
    filter: () => true,
    matchPos: 'start',
    getOptionLabel: (c)=>c.label,
    getOptionValue: (c)=>c.value,
    country: 'US'
  };

  filterAndMapOptions() {
    const {
      clearable,
      country,
      filter,
      getOptionLabel,
      getOptionValue
    } = this.props;

    const states = getStates(country)
      .filter(filter)
      .map((s) => ({
        label: getOptionLabel(s),
        value: getOptionValue(s)
      }));

    if (clearable) {
      states.unshift({ label: '', value: '' });
    }

    return states;
  }

  render() {
    return <Select
      options={this.filterAndMapOptions()}
      {...this.props}
    />;
  }
}
